function LargeButton({ children, type, disabled, onClick }) {
    return (
        <button
            className="inline-flex min-h-[3.5rem] items-center rounded-md border border-transparent bg-primary px-8 py-2 text-lg text-gray-100 shadow hover:bg-blue-800 disabled:border-gray-200 disabled:bg-gray-100 disabled:text-gray-400"
            type={type || 'button'}
            disabled={disabled}
            onClick={onClick}
        >
            {children}
        </button>
    );
}

export default LargeButton;
